var URLSearchParams = require('url-search-params')

export default function getAllUrlParams(url) {
  if (typeof window === 'undefined') {
    return {}
  }
  var queryString = window.location.search
  var utmMap = {}
  if (queryString) {
    var params = new URLSearchParams(queryString)
    utmMap['url_params'] = queryString
    for (var pair of params.entries()) {
      utmMap[pair[0]] = pair[1]
    }
  }
  return utmMap
}



// WEBPACK FOOTER //
// ./src/util/index.js